export default {"src":"/_next/static/media/delivery.69b616b6.svg","height":25,"width":26};